enum SurgeryTypeEnum {
    HOSPITALIZATION = 1,
    EMERGENCIES = 2,
    MINOR_AMBULATORY = 3,
    MAJOR_AMBULATORY = 4,
  }

  export default SurgeryTypeEnum;